import React from 'react';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    noticeContainer: {
        padding: '20px',
        maxWidth: '800px',
        margin: '0 auto',
        fontFamily: 'Arial, sans-serif',
        color: '#333',
        lineHeight: 1.6,
    },
    noticeTitle: {
        fontSize: '2.5em',
        fontWeight: 'bold',
        textAlign: 'center',
        color: '#1b2a4e',
        marginBottom: '30px',
    },
    noticeSection: {
        marginBottom: '30px',
    },
    noticeSubtitle: {
        fontSize: '1.5em',
        fontWeight: 'bold',
        color: '#1b2a4e',
        marginBottom: '10px',
    },
    noticeText: {
        margin: '5px 0',
        textAlign: 'justify',
        marginBottom: '16px',
    },
    noticeBold: {
        fontWeight: 'bold',
        margin: '5px 0',
        textAlign: 'justify',
        marginBottom: '16px',
    },
    indent: {
        marginLeft: '1rem',
        display: 'block'
    },
});

const LegalNoticeEN: React.FC = () => {
    const classes = useStyles();

    return (
        <div className={classes.noticeContainer}>
            <h1 className={classes.noticeTitle}>Legal Notice</h1>
            <p className={classes.noticeText}>
                This legal notice governs the use of this web application (hereinafter referred to as "web app") and will apply without prejudice to any other specific conditions that the user may accept. </p>
            <p className={classes.noticeBold}>
                PLEASE READ THESE TERMS CAREFULLY, AS ACCESSING AND/OR USING THE WEB APP SERVICE MEANS THAT YOU HAVE READ, UNDERSTOOD, AND ACCEPTED THEM WITHOUT RESERVATION. </p>
            <p className={classes.noticeText}>
                IMPORTANT NOTICE: Users are warned that this web app provides recommendations, which should never be used to make diagnoses, medical treatments, or any medical actions by healthcare professionals. The content of this web app does not replace personalized attention from healthcare professionals. </p>
            <p className={classes.noticeText}>
                The entity responsible for the application is the Servei Català de la Salut (hereinafter, CatSalut) with its address at Travessera de les Corts, 131-159 - Pavelló Olímpia, 08028 Barcelona. You can contact the Data Protection Officer at dpd@ticsalutsocial.cat </p>
            <p className={classes.noticeText}>
                To use the application, you must be over 16 years old. If you are under 16, your parents or guardians must access and accompany you through the site specifically provided in the application. </p>
            <p className={classes.noticeText}>  
                In accordance with the applicable regulations, we may also process your data for purposes of archiving in the public interest, research, or statistics, adopting the necessary technical and organizational measures, particularly ensuring compliance with the principle of data minimization, including its anonymization. These purposes will allow us to conduct an anonymized descriptive analysis of the situation, enabling us to understand the emotional health status of the population, as well as to design and implement measures and strategies to improve the quality of healthcare services, not only in the current emergency situation but also to prevent and detect similar situations that may occur in the future. </p>
            <p className={classes.noticeText}>
                The user declares to voluntarily access this web app, granting their consent, and accepting and acknowledging the legal warnings, conditions, and terms of use contained in this document. </p>
            <p className={classes.noticeText}>
                The use of this web app implies acquiring the status of a user and accepting the terms of use detailed below: </p>
            <section className={classes.noticeSection}>
                <p className={classes.noticeText}>
                    1. This web application (web app) contains guidance information related to various health aspects prepared by professionals. It offers recommendations, which should never be used to make diagnoses, medical treatments, or any medical actions by healthcare professionals. The content of this web app does not replace personalized attention from healthcare professionals.
                </p>
                <p className={classes.noticeText}>
                    2. The use of the web app is in accordance with the law, this legal notice, and any specific conditions that may apply. In case of non-compliance by the user, the Entity reserves the right to take appropriate legal action, as well as the right to restrict access to the application.
                </p>
                <p className={classes.noticeText}>
                    3. The Entity grants the user a non-exclusive, non-transferable, and free license solely for the private and personal use of the application. This license will have a duration equal to the legal relationship established in these conditions.
                </p>
                <p className={classes.noticeText}>
                    4. All contents of this web app (images, sounds, texts, files, logos, trademarks, design or source code, or any other element) are the property of the Entity or third parties who have authorized its use, and are protected by Spanish intellectual and industrial property legislation. Access to the contents of this web app does not transfer any rights over them. Specifically, and without limitation, the user may not use, access, copy, reproduce, transform or create derivative works, decompile, decode, reverse engineer, transfer, transmit, rent, distribute, license, sublicense, sell, or trade the web app and its contents or rights, or otherwise make the web app available without prior express written authorization from the Entity.
                </p>
                <p className={classes.noticeText}>
                    5. Reproduction -except for private use-, transformation, distribution, public communication, making available to the public, or any other exploitation of the contents of this web application (web app) without the express and written consent of the Entity is prohibited. In particular, the following behaviors are prohibited, by way of example:
                    <span className={classes.indent}>
                        a. The total or partial reproduction of the contents of the web application (web app), in any format.
                    </span>
                    <span className={classes.indent}>
                        b. The dissemination of the texts published in this web application (web app) without indicating the source.
                    </span>
                    <span className={classes.indent}>
                        c. The use or modification of trademarks, designs, logos, forms, or any other elements, in whole or in part.
                    </span>
                </p>
                <p className={classes.noticeText}>
                    6. Linking will only be allowed to the main page of the web application (web app), and practices such as framing (illicit display of selected content), deep-linking (hiding the source application address), etc., or any other practice that misleads about the origin of the content, are prohibited.
                </p>
                <p className={classes.noticeText}>
                    7. The establishment of links will not imply any relationship, collaboration, or support with the Entity. In particular, links that fraudulently induce or establish any type of relationship with the Entity are not allowed.
                </p>
                <p className={classes.noticeText}>
                    8. Links from defamatory, pornographic, racist pages, or those that provide false information about the Entity or any of its collaborators are prohibited.
                </p>
                <p className={classes.noticeText}>
                    9. The Entity periodically reviews and updates the information contained in this web application (web app). Consequently, the information or content of this web application (web app) should never be used to make diagnoses, medical treatments, or any medical actions by healthcare professionals. The content of this web application (web app) does not replace personalized attention from healthcare professionals.
                </p>
                <p className={classes.noticeText}>
                    10. Access to the web application (web app) is at the user's own risk, and it is the user's responsibility to use appropriate means to avoid any damage or viruses. Similarly, the user agrees to avoid any behavior that could damage, disable, deteriorate, overload, or harm the web application (web app) and its use in any way. The Entity is not responsible for any damages or harm the user may suffer due to misuse of the web application (web app).
                </p>
                <p className={classes.noticeText}>
                    11. To use the application, you must be over 16 years old. If you are under 16, your parents or guardians must access and accompany you through the site specifically provided in the application.
                </p>
                <p className={classes.noticeText}>
                    12. It is also warned that this legal notice and/or the privacy policy of this web application (web app) may undergo modifications of any kind when the Entity deems it appropriate or to adapt to future legislative and technological changes, which will be communicated to the user.
                </p>
                <p className={classes.noticeText}>
                    13. This web application (web app) is subject to the provisions of Spanish legislation. The courts of Barcelona will have jurisdiction to resolve any conflict that may arise from the use of this web application (web app).
                </p>
            </section>
            
            <h1 className={classes.noticeTitle}>Privacy Policy</h1>
            <p className={classes.noticeSubtitle}>Privacy Policy for this WebApp</p>
            <p className={classes.noticeText}>
                Please read this privacy policy carefully for the web application (web app) GestioEmocional.cat. Here you will find all the information related to what data we process about you, how we use it, and what control you have over your data.
            </p>
            <p className={classes.noticeText}>
                IMPORTANT NOTICE: To use the application, you must be over 16 years old. If you are under 16, your parents or guardians must access and accompany you through the site specifically provided in the application.
            </p>
            <section className={classes.noticeSection}>
                <h2 className={classes.noticeSubtitle}>Who is responsible for processing your data?</h2>
                <p className={classes.noticeText}>
                    The entity responsible for the application is the Servei Català de la Salut (hereinafter, CatSalut) with its address at Travessera de les Corts, 131-159 - Pavelló Olímpia, 08028 Barcelona.
                </p>
                <p className={classes.noticeText}>
                    You can contact the Data Protection Officer at dpd@ticsalutsocial.cat
                </p>
            </section>

            <section className={classes.noticeSection}>
                <h2 className={classes.noticeSubtitle}>What data do we collect about you?</h2>
                <p className={classes.noticeText}>
                    The application allows you to evaluate your emotional health automatically, without having to identify yourself, by answering a questionnaire of questions prepared by a team of psychologists.
                </p>
                <p className={classes.noticeText}>
                    Once the questionnaire is completed, and depending on the results, you may fill out a form, in case it is detected that your health status is not good, and provide your personal data so that a healthcare professional can contact you.
                </p>
                <span className={classes.indent}>
                    - The data we will ask for are:
                </span>
                <span className={classes.indent}>
                    - Identification and contact details:
                </span>
            </section>

            <section className={classes.noticeSection}>
                <h2 className={classes.noticeSubtitle}>What do we use your data for?</h2>
                <p className={classes.noticeText}>
                    The purpose of this web application (web app) is to provide citizens with resources for emotional management and support based on situations that may affect their emotional well-being.
                </p>
                <p className={classes.noticeText}>
                    In case the result of the test you take detects that your emotional health or that of your child or minor in your care is not good, and you choose to fill out the form, the data collected will be used so that a healthcare professional can contact you and provide support.
                </p>
                <p className={classes.noticeText}>
                    Additionally, in accordance with the applicable regulations, we may process your data for purposes of archiving in the public interest, research, or statistics, adopting the necessary technical and organizational measures, particularly ensuring compliance with the principle of data minimization, including its anonymization.
                </p>
                <p className={classes.noticeText}>
                    These purposes will allow us to conduct an anonymized descriptive analysis of the situation, enabling us to understand the emotional health status of the population, as well as to design and implement measures and strategies to improve the quality of healthcare services, not only in the current emergency situation but also to prevent and detect similar situations that may occur in the future.
                </p>
            </section>

            <section className={classes.noticeSection}>
                <h2 className={classes.noticeSubtitle}>How do we obtain your data?</h2>
                <p className={classes.noticeText}>
                    The data is what you provide us in case you perform the emotional evaluation proposed by the tool and fill out the contact form.
                </p>
                <p className={classes.noticeText}>
                    The data you provide must always be real, truthful, and up-to-date.
                </p>
            </section>

            <section className={classes.noticeSection}>
                <h2 className={classes.noticeSubtitle}>What is the legal basis for processing your data?</h2>
                <p className={classes.noticeText}>
                    All your data is collected with the purpose of providing citizens with resources for emotional management based on situations that may affect their emotional well-being and under the legal basis of the consent given by the data subject for the processing of their data (Articles 6.1 a and 9.2 a) of Regulation (EU) 2016/679, of April 27, 2016, on the protection of natural persons with regard to the processing of personal data and on the free movement of such data (GDPR).
                </p>
            </section>

            <section className={classes.noticeSection}>
                <h2 className={classes.noticeSubtitle}>How long will we keep your data?</h2>
                <p className={classes.noticeText}>
                    Your data will be kept for as long as necessary for the activation of healthcare services.
                </p>
            </section>

            <section className={classes.noticeSection}>
                <h2 className={classes.noticeSubtitle}>Who has access to this data?</h2>
                <p className={classes.noticeText}>
                    Healthcare professionals who need to contact you to provide support will have access to your data, in case you decide to fill out the form provided by the application after completing the evaluation test and based on the result obtained.
                </p>
                <p className={classes.noticeText}>Your data will be treated confidentially.</p>
            </section>

            <section className={classes.noticeSection}>
                <h2 className={classes.noticeSubtitle}>What rights do you have and how can you control your data?</h2>
                <p className={classes.noticeText}>
                    You can request access, rectification, deletion, restriction, or objection to the processing of your data. You can exercise your rights by contacting atenciociutadana@catsalut.cat. You can find more information at https://catsalut.gencat.cat/proteccio-dades.
                </p>
            </section>

            <section className={classes.noticeSection}>
                <h2 className={classes.noticeSubtitle}>How are your data protected?</h2>
                <p className={classes.noticeText}>
                    CatSalut adopts the necessary technical and organizational measures to ensure the security of information processing, maintain data confidentiality, and prevent loss or unauthorized access by unauthorized persons.
                </p>
            </section>
        </div>
    );
};

export default LegalNoticeEN;
